"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
require("./style.scss");
var PortalPage_1 = require("../_shared/components/PortalPage");
var model_1 = require("../../model");
var layout_1 = require("../_shared/components/layout");
var actions_1 = require("./actions");
var UserActions_1 = require("../userManagement/UserActions");
var ExcelExport_1 = require("../_shared/components/dataExport/ExcelExport");
var constants_1 = require("../../constants");
var CalendarBar_1 = require("../_shared/components/calendarBar/CalendarBar");
var daysExportData = [];
var ClosingMessagePage = /** @class */ (function (_super) {
    __extends(ClosingMessagePage, _super);
    function ClosingMessagePage(props) {
        var _this = _super.call(this, props) || this;
        _this.resetReportTable = function () {
            _this.props.resetReports();
            _this.updateExportData([]);
            _this.setState({ emptyReportsMsg: '' });
        };
        _this.onGenerateReportClick = function () {
            var _a = _this.state, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
            _this.props.getClosingMessage(dateFrom, dateTo).then(function () {
                _this.updateExportData(_this.sortArrayOfObjectsByDateDescending(_this.props.closingMessageReportData));
                _this.setState({ emptyReportsMsg: React.createElement("p", null, "Geen rapportgegevens") });
            });
        };
        _this.updateExportData = function (exportData) {
            _this.setState({ exportData: exportData });
        };
        _this.handleDateChange = function (dateFrom, dateTo) {
            _this.setState({ dateFrom: dateFrom, dateTo: dateTo }, function () {
                _this.resetReportTable();
            });
        };
        _this.state = {
            selectedUsers: [],
            dateFrom: moment().startOf('month').format(constants_1.DATE_FORMAT),
            dateTo: moment().format(constants_1.DATE_FORMAT),
            userSearchKeyword: '',
            emptyReportsMsg: '',
            exportData: []
        };
        return _this;
    }
    ClosingMessagePage.prototype.componentDidMount = function () {
        this.props.getClosingMessage(this.state.dateFrom, this.state.dateTo);
        this.updateExportData(this.sortArrayOfObjectsByDateDescending(this.props.closingMessageReportData));
    };
    ClosingMessagePage.prototype.renderReportTables = function () {
        var reports = this.props.closingMessageReportData;
        if (!(reports === null || reports === void 0 ? void 0 : reports.length)) {
            return this.state.emptyReportsMsg;
        }
        var sortedReports = this.sortArrayOfObjectsByDateDescending(reports);
        return (React.createElement(layout_1.Wrapper, { paddingVertical: "10px", key: "table-wrapper--".concat(reports.date) },
            React.createElement("table", { className: "border week-report-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { style: { width: '100px' } }, "Datum"),
                        React.createElement("th", { style: { width: '150px' } }, "Volledige naam"),
                        React.createElement("th", null, "Gebruikersnaam"),
                        React.createElement("th", null, "E-mail"),
                        React.createElement("th", null, "Slotbericht"))),
                React.createElement("tbody", null, sortedReports === null || sortedReports === void 0 ? void 0 : sortedReports.map(function (report) {
                    return (React.createElement("tr", { key: report.user._id },
                        React.createElement("td", null, moment(report.date).format('YYYY-MM-DD')),
                        React.createElement("td", null,
                            report.user.firstName,
                            " ",
                            report.user.lastName),
                        React.createElement("td", null, report.user.username),
                        React.createElement("td", null, report.user.email),
                        React.createElement("td", { style: { textAlign: 'center' } }, report.closeMessage)));
                })))));
    };
    ClosingMessagePage.prototype.sortArrayOfObjectsByDateDescending = function (arr) {
        var _a;
        var flattenedArray = (_a = arr === null || arr === void 0 ? void 0 : arr.reduce(function (acc, val) { return acc === null || acc === void 0 ? void 0 : acc.concat(val); }, [])) === null || _a === void 0 ? void 0 : _a.filter(Boolean);
        flattenedArray.sort(function (a, b) {
            var dateA = new Date(a === null || a === void 0 ? void 0 : a.date);
            var dateB = new Date(b === null || b === void 0 ? void 0 : b.date);
            return dateB - dateA;
        });
        return flattenedArray;
    };
    ClosingMessagePage.prototype.dataToExportData = function (data) {
        var records = data === null || data === void 0 ? void 0 : data.map(function (report) {
            return {
                name: moment(report.date).format('YYYY-MM-DD'),
                fullName: (0, model_1.getUserFullName)(report.user),
                username: report.user.username,
                email: report.user.email,
                closeMessage: report.closeMessage
            };
        });
        var sheet = {
            name: 'Sluit de werkdag notities',
            data: records
        };
        daysExportData.push(sheet);
        return daysExportData;
    };
    ClosingMessagePage.prototype.render = function () {
        var _this = this;
        var _a;
        var canGenerateReport = this.state.dateFrom && this.state.dateTo;
        var canExportReport = ((_a = this.state.exportData) === null || _a === void 0 ? void 0 : _a.length) > 0;
        var reportFileName = "Sluit de werkdag notities ".concat(moment(this.state.dateTo).format('YYYYMMDD'));
        if (this.state.dateTo !== this.state.dateFrom) {
            reportFileName += " tot ".concat(moment(this.state.dateFrom).format('YYYYMMDD'));
        }
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_CLOSING_DAY_REPORT, isLoading: this.props.isLoadingClosingMessage, id: "report" },
            React.createElement(layout_1.Row, { justifyContent: "flex-end" },
                React.createElement("span", { className: "button report-back-button", onClick: function () { return _this.props.history.goBack(); } }, "Ga Terug")),
            React.createElement(layout_1.Wrapper, { paddingVertical: "20px" },
                React.createElement("table", { className: "report-input-table" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Begindatum"),
                            React.createElement("th", null, "Einddatum"),
                            React.createElement("th", null, ''))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement(CalendarBar_1.default, { locale: constants_1.DEFAULT_LANGUAGE, date: this.state.dateFrom, name: "dateFrom", max: moment(), onDateChange: function (date) { return _this.handleDateChange(date, _this.state.dateTo); } })),
                            React.createElement("td", null,
                                React.createElement(CalendarBar_1.default, { locale: constants_1.DEFAULT_LANGUAGE, date: this.state.dateTo, name: "dateTo", max: moment(), onDateChange: function (date) {
                                        return _this.handleDateChange(_this.state.dateFrom, date);
                                    } })),
                            React.createElement("td", { className: "button-cell" },
                                React.createElement("button", { className: "button".concat(!canGenerateReport ? ' button-disabled' : ''), onClick: function () { return _this.onGenerateReportClick(); }, disabled: !canGenerateReport }, "Rapport opstellen"))))),
                React.createElement(layout_1.Wrapper, { className: 'report-wrapper' },
                    React.createElement(layout_1.Margin, { margin: "15px" }),
                    React.createElement(ExcelExport_1.default, { sheets: this.dataToExportData(this.state.exportData), fileName: reportFileName, bookType: "xlsx", buttonDisabled: !canExportReport }),
                    this.renderReportTables()))));
    };
    return ClosingMessagePage;
}(React.Component));
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        isLoadingClosingMessage: reducer.reportReducer.isLoadingClosingMessage,
        closingMessageReportData: reducer.reportReducer.closingMessageData,
        usersState: reducer.manageUsersState
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    getClosingMessage: function (dateFrom, dateTo) {
        return actions_1.Actions.getClosingMessage(dateFrom, dateTo)(dispatch);
    },
    searchUsers: function (searchParams) { return UserActions_1.UserActions.searchUsers(searchParams)(dispatch); },
    resetReports: function () { return actions_1.Actions.resetTimelinesReports()(dispatch); },
}); };
var closeMessagePage = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(ClosingMessagePage);
exports.default = closeMessagePage;
